<script lang="ts" setup>
import PrintingOrderTable from "@/data-views/tables/printing_order/PrintingOrderTable.vue";
definePage({
  meta: {
    action: "read",
    subject: "PrintingOrder",
    doNotActivate: true,
    navActiveLink: "printing-order-new",
  },
});

const loading = ref(false);

onMounted(() => {
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
  }, 500);
});
</script>

<template>
  <div>
    <PrintingOrderDeprecationNotice />
    <VRow class="match-height">
      <VCol cols="12">
        <PrintingOrderTable v-if="!loading" />
        <div v-else style="min-height: 50vh" />
      </VCol>
    </VRow>
  </div>
</template>
